__turbopack_context__.v({
  "footerText": "AppShell-module__hbANLa__footerText",
});
